export const API_ENDPOINT = "/api/v1";
